<app-guest-auth-main-layout>
  <ng-template>
    <div class="text-xl font-semibold py-2 px-3  mt-2 border-b border-secondary-500 text-primary-500">
      Reset Password
    </div>
    <form [formGroup]="resetPasswordForm" autocomplete="off" novalidate (ngSubmit)="submitForm(resetPasswordForm.value)">
      <div class="container-fluid">
        <div class="row my-2 text-center">
          <!-- BEGIN: PASSWORD FIELD -->
          <div class="col-md-12">
            <mat-form-field appearance="outline" class="material-form">
              <input
                placeholder="Enter new password"
                formControlName="password"
                matInput
              />
              <mat-icon matPrefix svgIcon="lock1" class="mx-2"></mat-icon>
              <mat-error *ngIf="resetPasswordForm.get('password').hasError('passwordPolicy')">
                Password must be at least 8 characters long, contain uppercase and lowercase letters, a number, and a special character.
              </mat-error>
            </mat-form-field>
          </div>
          <!-- END: PASSWORD FIELD -->
          <!-- BEGIN: PASSWORD FIELD -->
          <div class="col-md-12">
            <mat-form-field appearance="outline" class="material-form field">
              <input
                placeholder="Confirm Password"
                formControlName="confirmPassword"
                matInput
              />
              <mat-icon matPrefix svgIcon="lock1" class="mx-2"></mat-icon>
            </mat-form-field>
          </div>
          <!-- END: PASSWORD FIELD -->

          <!-- BEGIN:  BUTTON -->
          <div
            class="w-full flex justify-end items-center"
          >
            <button
              type="submit"
              mat-raised-button
              class="!bg-primary-500 !text-secondary-500 w-full !text-lg rounded-2xl shadow-lg px-3 py-3 "
            >
              Submit
            </button>

          </div>
          <!-- END:  BUTTON -->
        </div>
      </div>
    </form>

  </ng-template>
</app-guest-auth-main-layout>
